import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

function TestModal() {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    console.log('Button clicked!');
    setShowModal(true);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Modal Test Page</h1>
      <Button variant="primary" onClick={handleClick}>
        Test Modal Button
      </Button>

      {showModal && (
        <Modal show={true} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Test Modal</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>If you can see this modal, the buttons are working!</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default TestModal;
